import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { HandySvg } from "handy-svg";
import ReactInputMask from "react-input-mask";
import iconPointerLeft from "../../assets/icons/svg-sprite/point-arrow-left.svg";
import { feedback } from "../../lib/api/api";

const CallbackForm = () => {
  const [agreement, setAgreement] = useState(true);
  const [mobile, setMobile] = useState(true);
  const [name, setName] = useState(true);
  const [callback, setCallback] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    submitForm();
  }, []);

  function submitForm() {
    const formElement = document.getElementById("callback_modal_form");
    const SOURCE_ID = 3;
    const TYPE = 1;
    formElement.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(formElement);
      if (formData.get("callback_client_agree")) {
        setAgreement(true);
      } else {
        setAgreement(false);
      }
      if (formData.get("callback_client_phone")) {
        setMobile(true);
      } else {
        setMobile(false);
      }
      if (formData.get("callback_client_name")) {
        setName(true);
      } else {
        setName(false);
      }
      if (
        formData.get("callback_client_agree") &&
        formData.get("callback_client_phone") &&
        formData.get("callback_client_name")
      ) {
        feedback
          .callback(
            SOURCE_ID,
            TYPE,
            formData.get("callback_client_name"),
            formData.get("callback_client_phone")
          )
          .then((res) => {
            console.log(res);
            e.target.reset();
            setCallback(true);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  return (
    <>
      <div className="page__support-callback-overlay js-support-callback">
        <section className="support-callback">
          <div className="support-callback__header">
            <div className="support-callback__container">
              <button
                className="support-callback__back-btn js-support-callback-trigger"
                type="button"
              >
                <HandySvg
                  className="svg-icon"
                  src={iconPointerLeft}
                  width="19"
                  height="10"
                />
                Вернуться
              </button>
            </div>
          </div>
          <div className="support-callback__body" style={{ paddingTop: 40 }}>
            <div className="support-callback__container">
              <div
                className="support-callback__phone"
                style={{ borderBottom: "1px solid #ececec", marginBottom: 20 }}
              >
                <h3 className="support-callback__form-title title title--h2">
                  Свяжитесь с нами любым <br />
                  удобным для вас способом
                </h3>
              </div>
              <div
                className="support-callback__phone"
                style={{
                  marginTop: 30,
                  paddingBottom: 30,
                  borderBottom: "1px solid #ececec",
                  marginBottom: 10,
                }}
              >
                <span
                  className="support-callback__phone-value"
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: 100,
                    lineHeight: "1.5rem",
                  }}
                >
                  В разделе «Вопросы и ответы» мы собрали для <br />
                  вас ответы на часто задаваемые вопросы.
                </span>
                <div
                  className="support-callback__field"
                  style={{ paddingTop: 16 }}
                >
                  <Link
                    to="//telekarta.tv/support/faq"
                    className="support-callback__submit-btn solid-btn solid-btn--md solid-btn--blue bttn"
                  >
                    Найти ответ
                  </Link>
                </div>
              </div>
              <div
                className="support-callback__phone"
                style={{
                  marginTop: 30,
                  paddingBottom: 30,
                  borderBottom: "1px solid #ececec",
                  marginBottom: 10,
                }}
              >
                <div id="js-block-callback-form">
                  {callback ? (
                    <div className="js-support-callback-form">
                      <p>Спасибо! Мы свяжемся с Вами в ближайшее время</p>
                    </div>
                  ) : (
                    <form
                      className="support-callback__form js-support-callback-form"
                      id="callback_modal_form"
                      method="POST"
                    >
                      <h3
                        className="support-callback__form-title title title--h3"
                        style={{ marginBottom: 15 }}
                      >
                        Закажите обратный звонок
                      </h3>
                      <span
                        className="support-callback__phone-value"
                        style={{
                          fontSize: "1.1rem",
                          fontWeight: 100,
                          lineHeight: "1.5rem",
                          marginBottom: 15,
                        }}
                      >
                        Отправьте заявку и наш <br />
                        специалист свяжется с Вами.
                      </span>
                      <div className="support-callback__field">
                        <input
                          className={
                            "support-callback__input input input--md js-focus-outside required" +
                            (name ? "" : " has-error")
                          }
                          type="text"
                          placeholder="Ваше имя*"
                          name="callback_client_name"
                          id="callback_modal_form_property_client_name"
                        />
                        {!name && (
                          <div class="form__error active">Укажите имя</div>
                        )}
                      </div>
                      <div className="support-callback__field">
                        <ReactInputMask
                          mask="+7 (999) 999-9999"
                          value={phoneNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                            setPhoneNumber(value);
                          }}
                          className={
                            "support-callback__input input input--md js-focus-outside required" +
                            (mobile ? "" : " has-error")
                          }
                          placeholder="Номер телефона*"
                          name="callback_client_phone"
                          id="callback_modal_form_property_client_phone"
                        />
                        {!mobile && (
                          <div class="form__error active">
                            Укажите номер верно
                          </div>
                        )}
                      </div>
                      <div className="support-callback__field">
                        <div
                          className={
                            "checkbox checkbox--support-callback" +
                            (agreement ? "" : " has-error")
                          }
                          id="callback_modal_form_property_personal_data_agreement"
                        >
                          <input
                            className="checkbox__input required"
                            type="checkbox"
                            name="callback_client_agree"
                            id="callback_modal_form_property_personal_data_agreement_input"
                          />
                          <label
                            className="checkbox__label"
                            for="callback_modal_form_property_personal_data_agreement_input"
                          >
                            <span
                              className="checkbox__text"
                              style={{ position: "relative", top: "-10px" }}
                            >
                              Даю{" "}
                              <Link
                                className="link"
                                to="https://static.telekarta.tv/policy/ApprovalLkaAbonentsOrionExpress.pdf"
                                target="_blank"
                              >
                                согласие
                              </Link>{" "}
                              на обработку персональных данных
                              <br />в соответствии с{" "}
                              <Link
                                className="link"
                                to="https://static.telekarta.tv/policy/PrivacyPolicyOrion.pdf"
                                target="_blank"
                              >
                                Политикой обработки персональных данных
                              </Link>
                            </span>
                          </label>
                          {!agreement && (
                            <div class="form__error active">
                              Необходимо ваше согласие
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="support-callback__field">
                        <button
                          className="support-callback__submit-btn solid-btn solid-btn--md solid-btn--blue bttn"
                          type="submit"
                        >
                          Отправить форму
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
              <div
                className="support-callback__phone"
                style={{ marginTop: 25, marginBottom: 40 }}
              >
                <h3
                  className="support-callback__form-title title title--h3"
                  style={{ marginBottom: 20 }}
                >
                  Служба поддержки
                </h3>
                <span
                  className="support-callback__phone-value"
                  style={{ fontSize: "1.2rem", fontWeight: 100 }}
                >
                  +7 (800) 100-104-7
                </span>
                <span
                  className="support-callback__phone-value"
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: 100,
                    paddingTop: 12,
                  }}
                >
                  7 (495) 781-41-03 (МСК)
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CallbackForm;
